import { VacantRentalObject } from './vacant-rental-object';

export class VacantParking extends VacantRentalObject {
  constructor() {
    super();
  }

  parkingNumber: string;
}
